export enum ActionTypes {
  SAVE_EQUIPMENT_OPTIONS = 'SAVE_EQUIPMENT_OPTIONS'
}

/* export enum ActionTypes {
UPDATE_EQUIPMENT_LIST = 'UPDATE_EQUIPMENT_LIST'
} */